module.exports = __webpack_public_path__ + "img/clear.490a1c9f.svg";